import NoProfile from "src/assets/img/user-default.png";
import NoFavi from "src/assets/img/favi-default.png";
import ExampleFavi from "src/assets/img/favicon-example.png";
import NoLogo from "src/assets/img/logo-default.png";
import NoBusiness from "src/assets/img/business-default.png";

/* Digital Ocean: Example */
// export const apiPort = "";
// export const baseUrl = "https://domo-portal-admin-api-v2-uwrom.ondigitalocean.app";

export const apiPort = ":" + 3027;

/* Production */
export const baseUrl = `https://reports-admin.hsdmetrics.com${apiPort}`;

/* Localhost */
// export const baseUrl = `http://localhost${apiPort}`;

export const apiUrl = baseUrl + "/api";
export const filePath = baseUrl + "/uploads";
export const noProfile = NoProfile;
export const noFavi = NoFavi;
export const exampleFavi = ExampleFavi;
export const noLogo = NoLogo;
export const noBusiness = NoBusiness;

